import React from 'react';
import { subjectTemplateText } from './merge';

/** The last stop before an irreversible send, naming the exact count. */
export default function SendConfirm({
    owners, noun = 'owner', properties, noEmail, leftOut, stillBlank, listingBlanks = [], subject, sender, busy, onTest, onCancel, onConfirm,
}) {
    return (
        <div className="mm-overlay">
            <div className="mm-modal">
                <div className="mm-panel__title">
                    Send {owners} {owners === 1 ? 'email' : 'emails'}?
                </div>
                <div className="mm-modal__body">
                    One email to each of {owners} {owners === 1 ? noun : noun + 's'}
                    {/* null for a vendor or agent letter, which is about no property. */}
                    {properties == null ? '.' : ', covering ' + properties + (properties === 1 ? ' property.' : ' properties.')}
                    {noEmail > 0
                        ? ' ' + noEmail + (noEmail === 1 ? ' ' + noun : ' ' + noun + 's')
                            + ' without an email address ' + (noEmail === 1 ? 'is' : 'are') + ' skipped.'
                        : ''}
                    {leftOut > 0 ? ' ' + leftOut + ' you left out ' + (leftOut === 1 ? 'is' : 'are') + ' skipped too.' : ''}
                    {' '}Sending can&apos;t be undone.
                </div>

                {/* Named rather than blocked: the broker may know the gap is fine,
                    but they should not find out about it from the owner. */}
                {listingBlanks.length ? (
                    <div className="mm-alert--warn" style={{ margin: stillBlank > 0 ? '0 22px 10px' : '0 22px' }}>
                        Every letter has a blank for {listingBlanks.join(', ')}. Type it in beside the listing first.
                    </div>
                ) : null}
                {stillBlank > 0 ? (
                    <div className="mm-alert--warn" style={{ margin: '0 22px' }}>
                        {stillBlank} of them still {stillBlank === 1 ? 'has' : 'have'} a blank where the letter
                        expects a value. Check the &quot;Blanks in the letter&quot; tab first.
                    </div>
                ) : null}
                <div className="mm-modal__facts">
                    <div><span>From</span>{sender.name} &lt;{sender.mailbox || sender.email}&gt;</div>
                    {/* The template, not one recipient's version of it — this
                        dialog speaks for all of them. */}
                    <div><span>Subject</span>{subjectTemplateText(subject)}</div>
                </div>
                <div className="mm-modal__actions">
                    <button className="mm-linkbtn" onClick={onTest} disabled={busy}>Send a test to my inbox first</button>
                    <div className="mm-spacer"/>
                    <button className="mm-btn" onClick={onCancel} disabled={busy}>Cancel</button>
                    <button className="mm-btn mm-btn--primary" onClick={onConfirm} disabled={busy}>
                        Send {owners} {owners === 1 ? 'email' : 'emails'}
                    </button>
                </div>
            </div>
        </div>
    );
}
